<template>
  <div>
    <my-asidebar v-bind:active-tab="'sail'"> </my-asidebar>



    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Sefer</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li><a :href="basePath+'/sails'" class="text-white">Sefer </a></li>
                    <li>Detay</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <sail-detail></sail-detail>
      </div>
    </section>

  </div>
</template>

<script>
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";
import SailDetail from "../component/sail/SailDetail";


export default {
  name: "SailDetailPage",
  components: {SailDetail, MyAsidebar, TopBar},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights: {
      get() {
        return this.$store.getters.getPanelRightsMap;
      }
    },
    projectName:{
      get() {
        return this.$store.getters.getProjectName;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_SAIL_DETAIL"]) this.$router.push("/");
    if(this.$route.params.id !== undefined && this.$route.params.id !== 'new') {
      this.$store.dispatch("loadSailId", this.$route.params.id);
      this.$store.dispatch("loadLogoExportStatusList", {sailId: this.$route.params.id});
      this.$store.dispatch("loadSailAgencyProformaStatusList", {sailId: this.$route.params.id});
    }else{
      this.$nextTick(()=>{
        if(this.projectName === 'selectum'){
          this.$store.commit("setSail",{id:null,saleOpen:false, additionalServicePricingTemplateId:6})
        }else{
          this.$store.commit("setSail",{id:null,saleOpen:false})
        }


      })
    }

    this.$store.dispatch("loadSailsLite");
    this.$store.dispatch("loadCruiseList");
    this.$store.dispatch("loadSeaTourList");
    this.$store.dispatch("loadPricingTemplateList");
    this.$store.dispatch("loadAdditionalServicePricingTemplateList");
    this.$store.dispatch("loadPortList");
    this.$store.dispatch("loadCabinTypeList");
    this.$store.dispatch("loadAgencyList");
    this.$store.dispatch("loadRoomList");
    this.$store.dispatch("loadUserList");
  }
}
</script>

<style scoped>

</style>